type Props = { className?: string; title?: string }

export function BrandMark({ className = '', title }: Props) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      <circle cx="32" cy="32" r="24" stroke="currentColor" strokeWidth="4" />
      <circle cx="32" cy="32" r="5" fill="currentColor" />
      <g stroke="currentColor" strokeWidth="3" strokeLinecap="round">
        <line x1="32" y1="14" x2="32" y2="24" />
        <line x1="47.59" y1="23" x2="38.93" y2="28" />
        <line x1="47.59" y1="41" x2="38.93" y2="36" />
        <line x1="32" y1="50" x2="32" y2="40" />
        <line x1="16.41" y1="41" x2="25.07" y2="36" />
        <line x1="16.41" y1="23" x2="25.07" y2="28" />
      </g>
    </svg>
  )
}
